import React from "react";
import {
  Container,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import parseBlogContent from './parseBlogContent';
import blog2 from "../../assests/blog1.jpeg";
import { useTranslation } from "react-i18next";

const Blog2 = () => {
  const { t, i18n } = useTranslation();

  // Helper function to safely render HTML content within Typography
  const renderHTML = (key, props = {}) => {
    return (
      <Typography component="div" variant="body1" color="text.secondary" sx={{ mb: 3 }} {...props}>
        {parseBlogContent(t(key), i18n.language)}
      </Typography>
    );
  };

  return (
    <Container component="article" maxWidth="md" sx={{ p: 0 }}>
      <Box sx={{ my: 10 }}>
        <Card sx={{ backgroundColor: "transparent", p: { xs: 1, md: 5 } }}>
          <Typography
            variant="h1"
            sx={{
              mb: 5,
              color: "black",
              fontSize: { xs: "1.75rem", sm: "2.25rem" },
            }}
          >
            {t("title2")}
          </Typography>
          <CardMedia
            component="img"
            image={blog2}
            alt={t("Web Development")}
            sx={{ height: "auto", width: "100%", mb: 5 }}
          />
          <CardContent>
            {renderHTML("description2")}
            {renderHTML("subDescription6")}
            <h2 variant="h2" color="text.secondary" sx={{ mb: 3 }}>
              {t("subDescription7")}
            </h2>
            {renderHTML("subDescription38")}
            {renderHTML("subDescription8")}
            {renderHTML("subDescription9")}
            {renderHTML("subDescription10")}
            {renderHTML("subDescription11")}
            {renderHTML("subDescription12")}
            {renderHTML("subDescription13")}
            {renderHTML("subDescription14")}
            {renderHTML("subDescription15")}
            <h2 variant="h2" color="text.secondary" sx={{ mb: 3 }}>
              {t("subDescription16")}
            </h2>
            {renderHTML("subDescription17")}
            {renderHTML("subDescription18")}
            {renderHTML("subDescription19")}
            {renderHTML("subDescription20")}
            {renderHTML("subDescription21")}
            {renderHTML("subDescription22")}
            {renderHTML("subDescription23")}
            {renderHTML("subDescription24")}
            {renderHTML("subDescription25")}
            {renderHTML("subDescription26")}
            {renderHTML("subDescription27")}
            {renderHTML("subDescription28")}
            <h3 color="text.secondary" sx={{ mb: 3 }}>
              {t("subDescription29")}
            </h3>
            {renderHTML("subDescription30")}
            {renderHTML("subDescription31")}
            {renderHTML("subDescription32")}
            {renderHTML("subDescription33")}
            {renderHTML("subTitle3")}
            <h3 color="text.secondary" sx={{ mb: 3 }}>
              {t("subDescription34")}
            </h3>
            {renderHTML("subDescription35")}

            {renderHTML("subDescription36")}

            <br />
            {renderHTML("subDescription37")}
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Blog2;
